import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["color", "displayValueFormatter", "height", "max", "value", "width"],
  _excluded2 = ["displayValueFormatter", "value"];
import { filterProps } from '../../../utils/filterProps';
import styled from 'foundations-theming/utils';
import I18n from 'I18n';
import { useMapTokenPropsToCSS } from '../../../hooks/useMapTokenPropsToCSS';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const Bar = styled.div.withConfig({
  displayName: "InlineBarChart__Bar",
  componentId: "sc-2fsc03-0"
})(({
  $height,
  $width,
  $color,
  theme
}) => {
  return {
    borderRadius: `${theme.borderRadius['0']} ${theme.borderRadius['100']} ${theme.borderRadius['100']} ${theme.borderRadius['0']}`,
    backgroundColor: theme.color[$color],
    blockSize: $height,
    inlineSize: `${$width}%`
  };
});
const Outer = styled.div.withConfig({
  displayName: "InlineBarChart__Outer",
  componentId: "sc-2fsc03-1"
})(({
  $width,
  $cssStyles
}) => {
  return Object.assign({
    display: 'inline-block',
    verticalAlign: 'middle',
    inlineSize: $width
  }, $cssStyles);
});
export const InlineBarChart = _ref => {
  let {
      color = 'fill-brand-hover',
      height = 20,
      max = 100,
      value = 0,
      width = 200
    } = _ref,
    rest = _objectWithoutPropertiesLoose(_ref, _excluded);
  const {
    domProps,
    tokenProps
  } = filterProps(rest);
  const cssStyles = useMapTokenPropsToCSS(tokenProps);
  if (value === 0) return null;
  const valueWidth = Math.max(Math.min(Math.floor(value / max * 100), 100), 1);
  return /*#__PURE__*/_jsx(Outer, Object.assign({
    $width: width,
    $cssStyles: cssStyles
  }, domProps, {
    children: /*#__PURE__*/_jsx(Bar, {
      $height: height,
      $width: valueWidth,
      $color: color
    })
  }));
};
const NumberCell = styled.td.withConfig({
  displayName: "InlineBarChart__NumberCell",
  componentId: "sc-2fsc03-2"
})(["&&{padding-right:calc( ", " + ", " );text-align:right;}"], ({
  theme
}) => theme.space['400'], ({
  theme
}) => theme.space['50']);
const ChartCell = styled.td.withConfig({
  displayName: "InlineBarChart__ChartCell",
  componentId: "sc-2fsc03-3"
})(["&&{padding-left:", ";}"], ({
  theme
}) => theme.space['0']);
InlineBarChart.renderTableCells = _ref2 => {
  let {
      displayValueFormatter = I18n.formatNumber,
      value = 0
    } = _ref2,
    rest = _objectWithoutPropertiesLoose(_ref2, _excluded2);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(NumberCell, {
      children: displayValueFormatter(value)
    }), /*#__PURE__*/_jsx(ChartCell, {
      children: /*#__PURE__*/_jsx(InlineBarChart, Object.assign({
        value: value
      }, rest))
    })]
  });
};